import { RouteConfig } from 'vue-router'

const Layout = () => import('../views/Layout.vue')
const Index = () => import('@/views/TeachSourceIndex.vue')
const Detail = () => import('@/views/TeachSourceDetail.vue')
const Collect = () => import('@/views/TeachSourceCollect.vue')
const Topic = () => import('@/views/TeachSourceTopic.vue')
const Mine = () => import('@/views/TeachSourceMine.vue')
const Edit = () => import('@/views/TeachSourceEdit.vue')

export const indexRoute: RouteConfig = {
  path: 'index',
  name: 'teach_index',
  component: Index,
  meta: { title: '教案资源库', showMenu: true },
}

export const detailRoute: RouteConfig = {
  path: 'detail',
  name: 'teach_detail',
  component: Detail,
  props: (route) => ({ id: route.query.id }),
  meta: { title: '教案资源库', showMenu: false },
}

export const collectRoute: RouteConfig = {
  path: 'collect',
  name: 'teach_collect',
  component: Collect,
  meta: { title: '教案资源库', showMenu: false },
}

export const topicRoute: RouteConfig = {
  path: 'topic',
  name: 'teach_topic',
  component: Topic,
  props: (route) => ({ id: route.query.id }),
  meta: { title: '教案资源库', showMenu: false },
}

export const mineRoute: RouteConfig = {
  path: 'mine',
  name: 'teach_mine',
  component: Mine,
  meta: { title: '我的教案', showMenu: true },
}

export const editRoute: RouteConfig = {
  path: 'edit',
  name: 'teach_edit',
  component: Edit,
  meta: { title: '我的教案', showMenu: false },
}
import teachMenuIcon from '@/assets/images/icon_menu_teach@2x.png'
import teachMenuIconActive from '@/assets/images/icon_menu_teach_active@2x.png'

export default [
  {
    path: '/teach',
    name: 'teach',
    component: Layout,
    meta: { title: '教学资源', icon: teachMenuIcon, iconActive: teachMenuIconActive, showMenu: true },
    children: [indexRoute, detailRoute, collectRoute, topicRoute, mineRoute, editRoute],
  },
]
